
<template>

	<mymodal ref="modal" title="Импорт выбросов" ok="Импортировать" :reset="reset" :check="check" :submit="submit">

		<b-overlay :show="wait">

			<b-form-group :state="fl_state" label="Файл" invalid-feedback="Необходимо указать файл">
				
				<b-form-file :state="fl_state" v-model="fl" placeholder="Файл" v-on:change="load_file" accept=".xlsx"/>

			</b-form-group>

			<b-form-group :state="sheet_state" label="Страница" invalid-feedback="Необходимо указать страницу">

				<v-select :state="sheet_state" :clearable="false" v-model="sheet" :options="wb.SheetNames" v-on:input="sheet_select" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="first_row_ind_state" label="Начальная строка импорта" invalid-feedback="Необходимо указать начальную строку импорта">

				<b-form-input type="number" :state="first_row_ind_state" v-model="first_row_ind" min="2"/>

			</b-form-group>

			<b-form-group :state="name_state" label="Код группировки" invalid-feedback="Необходимо указать столбец с кодом группировки">

				<v-select :state="name_state" :clearable="false" label="name" v-model="name" :options="attrs_xlsx_visible" :reduce="obj => obj.id" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="bad_state" label="Выброс" invalid-feedback="Необходимо указать столбец выбросов">

				<v-select :state="bad_state" :clearable="false" label="name" v-model="bad" :options="attrs_xlsx_visible" :reduce="obj => obj.id" clearSearchOnSelect required appendToBody/>

			</b-form-group>

		</b-overlay>

	</mymodal>

</template>

<script>

import XLSX from "xlsx"
import api from "../../../../../../api"
import attrs from "../../../../../../api/attrs"
import mymodal from "../../../../../widgets/modal"

export default
{
	props :
	{
		group_id : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			name_attr_id : null,
			bad_attr_id : null,

			fl : null,
			fl_state : null,

			wb : { sheets : [] },

			sheet : null,
			sheet_state : null,

			attrs_xlsx : [],
			attrs_xlsx_visible : [],

			first_row_ind : 2,
			first_row_ind_state : null,
			name : null,
			name_state : null,
			bad : null,
			bad_state : null,

			wait : false,

		}
	},

	mounted()
	{
		attrs.get(this).then(
			desc =>
			{
				this.name_attr_id = desc.attrs.find(attr => attr.key == "attrs.group_code").id
				this.bad_attr_id = desc.attrs.find(attr => attr.key == "attrs.bad").id
			})
	},

	methods :
	{
		reset()
		{
			this.fl = null
			this.fl_state = null
			this.wb = { sheets : [] }
			this.sheet = null
			this.sheet_state = null
			this.attrs_xlsx = []
			this.attrs_xlsx_visible = []
			this.first_row_ind = 2
			this.first_row_ind_state = null
			this.name = null
			this.name_state = null
			this.bad = null
			this.bad_state = null
			this.wait = false

			this.refresh_visible_attrs()
		},

		check()
		{
			this.fl_state = !! this.fl
			this.sheet_state = !! this.sheet
			this.first_row_ind_state = !! this.first_row_ind
			this.name_state = !! this.name
			this.bad_state = !! this.bad

			return this.fl_state && this.sheet_state && this.first_row_ind_state && this.name_state && this.bad_state
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		load_file(event)
		{
			if(event.target.files)
			{
				const reader = new FileReader()
			
				reader.onload =
					event =>
					{
						const raw = event.target.result
						
						this.wb = XLSX.read(raw, { type : "binary", sheetRows : 30 })

						this.sheet = null
						this.sheet_state = null
						this.attrs_xlsx = []
						this.name = null
						this.bad = null

						if(this.wb.SheetNames.length)
							this.sheet_select(this.wb.SheetNames[0])

						this.wait = false

						this.set_all_attrs_to_visible()
					}

				this.wait = true

				reader.readAsBinaryString(event.target.files[0])
			}
		},

		sheet_select(sheet_name = null)
		{
			if(sheet_name != null)
				this.sheet = sheet_name

			this.attrs_xlsx = []
			this.name = null
			this.bad = null

			const ws = this.wb.Sheets[this.sheet]
			const range = XLSX.utils.decode_range(ws["!ref"])

			for(var col = range.s.c; col <= range.e.c; col++)
			{
				var cell = ws[XLSX.utils.encode_cell({ c : col, r : 0 })]

				if(cell)
					this.attrs_xlsx.push({ name : cell.v, id : col + 1 })
			}
				
			this.set_all_attrs_to_visible()
			this.refresh_visible_attrs()
		},

		set_all_attrs_to_visible()
		{
			this.attrs_xlsx.forEach(attr => { attr.visible = true })
		},

		refresh_visible_attrs()
		{
			this.attrs_xlsx_visible = this.attrs_xlsx.filter(attr => attr.visible || attr.visible == null)
		},

		submit()
		{
			const reader = new FileReader()
			this.wait = true

			reader.onload =
				fl =>
				{
					api.upload_file(this, fl, this.fl.name, this.fl.name,
						response =>
						{
							var params = {

								file : response.id,
								sheet : this.sheet,
								primary_attr : this.name_attr_id,
								connections :
								[
									{ attr_xlsx : this.name, attr : this.name_attr_id },
									{ attr_xlsx : this.bad, attr : this.bad_attr_id }
								],
								first_row_ind : Number(this.first_row_ind),
								strict : true,
								group_id : this.group_id,

							}

							this.wait = false

							api.call_long_operation(this, "Импорт выбросов запущен", "cadastral_analogues", "import_attrs_from_xlsx", params,
								response =>
								{
									api.delete_file(this, params.file)
									api.open_response_url(response)

									this.wait = true

									this.$emit("need_refresh")
								},
								{
									success_msg : "Импорт выбросов завершен",
									error_func : api.default_error_func
								},
								false
							)
						})
				}
			
			reader.readAsBinaryString(this.fl)
		}
	}
}

</script>

